const envDemoMode = (process.env.REACT_APP_DEMO_MODE || '').toLowerCase() === 'true';

export const isDemoMode = () => {
  if (envDemoMode) return true;
  if (typeof window === 'undefined') return false;
  return window.location.hostname.toLowerCase().startsWith('demo.');
};

export const isDemoRouteDisabled = (path) => {
  if (!isDemoMode()) return false;
  return path === '/efatura/giden' || path === '/efatura/gelen';
};

export const getDemoCredentials = () => ({
  username: process.env.REACT_APP_DEMO_USERNAME || '',
  password: process.env.REACT_APP_DEMO_PASSWORD || '',
});

export const getApiUrl = () => {
  if (isDemoMode()) {
    return process.env.REACT_APP_DEMO_API_URL || process.env.REACT_APP_API_URL || '';
  }
  return process.env.REACT_APP_API_URL || '';
};
